import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';
import { Event as EventService } from '../services/event';
import { NetworkService } from '../services/network';

/**
 * Accès réservé aux MEMBRES (espaces sensibles : contributions, dépenses, chat,
 * retraits, groupes). La fiche détail publique passe par `eventViewGuard`.
 */
export const eventMemberGuard: CanActivateFn = async (route) => {
  const auth = inject(Auth);
  const eventService = inject(EventService);
  const router = inject(Router);
  const network = inject(NetworkService);

  // Attendre la restauration de session (cold reload) avant la lecture Firestore.
  await auth.authReady;

  const eventId = route.paramMap.get('eventId');
  if (!eventId) return router.createUrlTree(['/home']);

  try {
    const isMember = await eventService.isMember(eventId);
    return isMember ? true : router.createUrlTree(['/home']);
  } catch {
    // Offline: allow navigation — Firestore cache may serve the data
    if (!network.isOnline()) return true;
    return router.createUrlTree(['/home']);
  }
};
